import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const location = useLocation();

    const isCatalogPage = location.pathname.includes('/catalog');
    const isFormPage =
        location.pathname.includes('/visit_showroom') ||
        location.pathname.includes('/test-drive-appointment') ||
        location.pathname.includes('/service-appointment') ||
        location.pathname.includes('/poluchit-predlozhenie') ||
        location.pathname.includes('/appointment');

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const closeAll = () => setIsOpen(false);

    const headerBackground = (isScrolled || isCatalogPage || isFormPage)
        ? '#000'
        : 'linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, transparent 100%)';

    // just text line

    return (
        <>
            <header className="header" style={{ background: headerBackground }}>
                <div className="header-menu-trigger" onClick={() => setIsOpen(true)}>
                    <div className="header-line"></div>
                    <div className="header-line"></div>
                </div>

                {!isMobile && (
                    <div>
                        <Link to="/" className="header-logo-link">PREMIUM AUTO</Link>
                    </div>
                )}

                {!isMobile && (
                    <div className="header-lang-switch">
                        <span>РУССКИЙ</span> | <span>O'ZBEKCHA</span>
                    </div>
                )}
            </header>

            <div
                className="header-drawer"
                style={{
                    width: isMobile ? '100%' : '350px',
                    left: isMobile ? '0' : '20px',
                    top: isMobile ? '0' : '20px',
                    height: isMobile ? '100%' : 'calc(100% - 40px)',
                    borderRadius: isMobile ? '0' : '5px',
                    transform: isOpen ? 'translateX(0)' : 'translateX(-110%)',
                    opacity: isOpen ? 1 : 0
                }}
            >
                <div className="header-drawer-header">
                    {isMobile && (
                        <Link to="/" className="header-mobile-drawer-logo" onClick={closeAll}>
                            PREMIUM AUTO
                        </Link>
                    )}
                    <div className="header-close-btn" onClick={() => setIsOpen(false)}>✕</div>
                </div>

                <nav className="header-nav">
                    <Link to="/" className="header-nav-link" onClick={closeAll}>Главное меню</Link>
                    <Link to="/catalog/new" className="header-nav-link" onClick={closeAll}>BMW в наличии</Link>
                    <Link to="/catalog/used" className="header-nav-link" onClick={closeAll}>BMW c пробегом</Link>
                    <Link to="/poluchit-predlozhenie" className="header-nav-link" onClick={closeAll}>Получить предложение</Link>
                    <Link to="/visit_showroom" className="header-nav-link" onClick={closeAll}>Онлайн-запись на визит в шоурум</Link>
                    <Link to="/test-drive-appointment" className="header-nav-link" onClick={closeAll}>Онлайн-запись на тест-драйв</Link>
                    <Link to="/service-appointment" className="header-nav-link" onClick={closeAll}>Онлайн-запись на сервис</Link>
                    <Link to="/about" className="header-nav-link" onClick={closeAll}>О нас</Link>
                    <Link to="/contacts" className="header-nav-link" onClick={closeAll}>Контакты</Link>
                </nav>

                {isMobile && (
                    <div className="header-mobile-drawer-lang">
                        <span className="header-active-lang">РУССКИЙ</span>
                        <span style={{ color: '#ccc' }}>|</span>
                        <span>O'ZBEKCHA</span>
                    </div>
                )}
            </div>

            {isOpen && <div className="header-overlay" onClick={() => setIsOpen(false)}></div>}
        </>
    );
};

export default Header;